import { render } from "./partener_infos_modal.vue?vue&type=template&id=830fa84a"
import script from "./partener_infos_modal.vue?vue&type=script&lang=js"
export * from "./partener_infos_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__